import {
  clientFindAuthorizationPath,
  serverFindAuthorizationPath,
} from 'functions/findAuthorizationPath'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

/**
 * Мы возвращаем один из двух путей: '/', '/select-gender'.
 * Первый возвращается в случае, если есть кука start_with_auth_form,
 * которую ставит сервер при успешной авторизации.
 */
export const useAuthorizationPath = (): string => {
  const { cookies } = useShallowEqualSelector(
    ({ systemReducer: { cookies } }) => ({ cookies })
  )

  if (process.env.browser) {
    return clientFindAuthorizationPath()
  }
  return serverFindAuthorizationPath(cookies)
}
